import React, { useEffect } from "react";
import * as THREE from "three";

export function useCanvas() {
  // console.clear();

  let scene = new THREE.Scene();
  scene.background = new THREE.Color(0x000000);
  let camera = new THREE.PerspectiveCamera(
    60,
    window.innerWidth / window.innerHeight,
    1,
    1000
  );
  camera.position.set(0, 0, 0); // Closer to the origin

  let renderer = new THREE.WebGLRenderer();

  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.appendChild(renderer.domElement);

  window.addEventListener("resize", () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  });

  let gu = {
    time: { value: 0 },
  };

  let sizes = [];
  let shift = [];
  let pushShift = () => {
    shift.push(
      Math.random() * Math.PI,
      Math.random() * Math.PI * 2,
      (Math.random() * 0.9 + 0.1) * Math.PI * 0.1,
      Math.random() * 2 + 0.1
    );
  };

  let pts = new Array(100000).fill().map((p) => {
    sizes.push(Math.random() * 2 + 0.5);
    pushShift();
    return new THREE.Vector3()
      .randomDirection()
      .multiplyScalar(Math.random() * 2 + 5.5);
  });
  for (let i = 0; i < 1000; i++) {
    let r = 5,
      R = 20;
    let rand = Math.pow(Math.random(), 1.5);
    let radius = Math.sqrt(R * R * rand + (1 - rand) * r * r);
    pts.push(
      new THREE.Vector3().setFromCylindricalCoords(
        radius,
        Math.random() * 2 * Math.PI,
        (Math.random() - 0.5) * 2
      )
    );
    sizes.push(Math.random() * 1.5 + 0.5);
    pushShift();
  }

  let g = new THREE.BufferGeometry().setFromPoints(pts);
  g.setAttribute("sizes", new THREE.Float32BufferAttribute(sizes, 1));
  g.setAttribute("shift", new THREE.Float32BufferAttribute(shift, 4));

  let m = new THREE.ShaderMaterial({
    uniforms: {
      time: gu.time,
      color: { value: new THREE.Color(0xffffff) },
      size: { value: 0.2 },
    },
    vertexShader: `
        uniform float time;
        uniform vec2 mousePos;
        uniform float size;
        attribute float sizes;
        attribute vec4 shift;
        varying vec3 vColor;

        void main() {
            float t = time;
            float PI2 = 6.28318530718;
            float moveT = mod(shift.x + shift.z * t, PI2);
            float moveS = mod(shift.y + shift.z * t, PI2);
            
            vec3 mousePos3 = vec3(mousePos.x, mousePos.y, 0.0);
            vec3 toMouse = mousePos3 - position;
            float distanceToMouse = length(toMouse);
        
            float minDistance = 0.8;
            float maxDistance = 1.0;
            float baseAttractionStrength = 0.05;
            
            float smoothStep = smoothstep(minDistance, maxDistance, distanceToMouse);
            float attractionStrength = baseAttractionStrength * (1.0 - smoothStep);
        
            // Increase the attraction strength the further the mouse is from the center of the screen
            attractionStrength *= abs(mousePos.x) * 2.0;
        
            vec3 attraction = toMouse * attractionStrength;
        
            vec3 newPos = position + vec3(cos(moveS) * sin(moveT), cos(moveT), sin(moveS) * sin(moveT)) * shift.w;
            newPos += attraction;
        
            vec4 mvPosition = modelViewMatrix * vec4(newPos, 1.0);
            gl_PointSize = size * sizes * (300.0 / -mvPosition.z);
            gl_Position = projectionMatrix * mvPosition;
        
            float d = length(abs(newPos) / vec3(10., 30., 20));
            d = clamp(d, 0., 1.);
            vColor = mix(vec3(0., 0., 0.), vec3(117., 251., 253.), d) / 800.;
        }
    `,
    fragmentShader: `
        varying vec3 vColor;
    
        void main() {
            float d = length(gl_PointCoord.xy - 0.5);
            if (d > 0.5) discard;
            gl_FragColor = vec4(vColor, smoothstep(0.2, 0.1, d));
        }
    `,
    transparent: true,
    depthTest: false,
    blending: THREE.AdditiveBlending,
  });

  let p = new THREE.Points(g, m);
  p.rotation.order = "ZYX";
  p.rotation.z = 0.1;
  scene.add(p);

  let clock = new THREE.Clock();

  renderer.setAnimationLoop(() => {
    let t = clock.getElapsedTime() * 0.5;
    gu.time.value = t * Math.PI;
    p.rotation.y = t * 0.5;
    renderer.render(scene, camera);
  });

  let zoomSpeed = 0.03;
  let hasClicked = false;
  let flags = { hasClicked: false };

  var mousePos = { x: 0, y: 0 };
  window.addEventListener("mousemove", function (event) {
    mousePos.x = (event.clientX / window.innerWidth) * 2 - 1;
    mousePos.y = -(event.clientY / window.innerHeight) * 2 + 1;
  });

  var panSpeed = 0.4;
  var lagFactor = 0.05;

  function lerp(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
  }

  renderer.setAnimationLoop(() => {
    let t = clock.getElapsedTime() * 0.1;
    gu.time.value = t * Math.PI;
    p.rotation.y = t * 0.01;

    if (!flags.hasClicked) {
      var targetX = -mousePos.x * panSpeed;
      var targetY = -mousePos.y * panSpeed;
      var targetZ = 18 - camera.position.z * zoomSpeed;

      camera.position.x = lerp(camera.position.x, targetX, lagFactor);
      camera.position.y = lerp(camera.position.y, targetY, lagFactor);
      camera.position.z = lerp(camera.position.z, targetZ, lagFactor);
    }

    renderer.render(scene, camera);
  });

  return { camera, flags };
}
